import { create } from 'zustand';

const useContactPersonListStore = create((set) => ({
  contactpersonList: [],

  setContactpersonList: (newContactperson) =>
    set((state) => ({
      contactpersonList: [...state.contactpersonList, newContactperson],
    })),

  removeContactpersonByIndex: (index) =>
    set((state) => ({
      contactpersonList: state.contactpersonList.filter((_, i) => i !== index),
    })),

  clearContactpersonList: () => set({ contactpersonList: [] }),
}));

export default useContactPersonListStore;
